var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CChartLine',{attrs:{"datasets":_vm.chartData.datasets,"labels":_vm.chartData.labels,"options":_vm.chartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }